import { render, staticRenderFns } from "./btn_excel_export.vue?vue&type=template&id=0b230e45&scoped=true"
import script from "./btn_excel_export.vue?vue&type=script&lang=js"
export * from "./btn_excel_export.vue?vue&type=script&lang=js"
import style0 from "./btn_excel_export.vue?vue&type=style&index=0&id=0b230e45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b230e45",
  null
  
)

export default component.exports